module.exports = __webpack_public_path__ + "static/media/4.a40a3ac6.jpg";